import { useEffect, useState } from "react";
import srcRight from "../../placeholder/right.jpg";
import srcLeft from "../../placeholder/left.jpg";
import Agamographe from "./Agamographe.js";
import Image from "./Image";
import QteBandes from "./QteBandes";
import { jsPDF } from "jspdf";

function Tool() {
    const [croppedRight, setCroppedRight] = useState(undefined);
    const [croppedLeft, setCroppedLeft] = useState(undefined);
    const [qteBandes, setQteBandes] = useState(5);

    const downloadPdf = (img) => {
        const doc = new jsPDF({
            orientation: "l",
            unit: "mm",
            format: "a4",
        });
        doc.addImage(img, "PNG", 10, 10, 277, 190, "agamographe", "FAST");
        doc.save("agamographe.pdf");
    };
    return (
        <div className="container">
            <QteBandes qteBandes={qteBandes} setQteBandes={setQteBandes} />
            <div className="container mb-2">
                <div className="row">
                    <Image src={srcLeft} onChangeCrop={setCroppedLeft} />
                    <Image src={srcRight} onChangeCrop={setCroppedRight} />
                </div>
            </div>
            <div className="container my-3">
                {croppedLeft && croppedRight ? (
                    <Agamographe
                        left={croppedLeft}
                        right={croppedRight}
                        n={qteBandes}
                        onClick={downloadPdf}
                    />
                ) : (
                    <h1 className="alert alert-danger text-center">
                        Positionnez et/ou modifiez la zone à utiliser sur
                        chacune des images.
                    </h1>
                )}
            </div>
        </div>
    );
}

export default Tool;
